import PropTypes from 'prop-types';
import React from 'react';

import useIsMobile from 'lib/useIsMobile';

const styles = {
  h5: { alignSelf: 'flex-start' },
  mobile: { paddingLeft: 10 },
};

const PageSubHeading = ({ children }) => {
  const mobile = useIsMobile();
  return (
    <h5
      style={{
        ...styles.h5,
        ...(mobile ? styles.mobile : {}),
      }}
    >
      {children}
    </h5>
  );
};

PageSubHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageSubHeading;
